import { useState } from 'react';
import useTranslations from '../../hooks/useTranslations';
import './select.scss';

const Select = ({
  register,
  name,
  error,
  defaultValue,
  label,
  className,
  options,
  onChange,
  disabled,
  disabledSelect = true,
  marginSelect,
  editable,
  marginTop = false,
}) => {
  const [focus, setFocus] = useState(false);
  const { t } = useTranslations();

  return (
    <div
      className={`${className} bg-white dark:bg-transparent relative ${marginTop ? 'marginTop-class-select' : ''}`}
      style={{ marginTop: '-6.5px' }}>
      <label
        className={`w-full dark:text-white ${editable && 'custom-select-label'} ${
          focus ? 'custom-select-label-focus' : ''
        } ${error?.message ? 'select-error' : ''}`}>
        <span className=' dark:text-white custom-input-label-active font-bold truncate absolute'>{label}</span>
        <div className='custom-select-container'>
          <select
            name={name}
            className={`custom-select custom-select-input  truncate ${marginSelect ? marginSelect : 'mt-4'}`}
            ref={register}
            onChange={onChange}
            value={defaultValue || ''}
            disabled={disabled}
            autoComplete='off'
            autoCorrect='off'
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}>
            <option className='' value='' key='SELECT' disabled={disabledSelect}>
              {t('SELECT')}
            </option>
            {options &&
              options.map((option, index) => (
                <option className='' value={option.id} key={index}>
                  {t(option.name) ?? option.name}
                </option>
              ))}
            {(name === 'instituteId' || name === 'formationCareerId') && <option value='Other'>{t('OTHER')}</option>}
          </select>
        </div>
      </label>
      {error && <span className='danger-text absolute bottom-0 select-container-danger-text'>{error?.message}</span>}
    </div>
  );
};

export default Select;
